import {ReactNode} from 'react'

interface IDrop {
  children: ReactNode
  icon?: JSX.Element
}

const DropRoot = ({children, icon}: IDrop) => {
  return (
    <div className='dropdown'>
      <button
        className='btn btn-link btn-color-muted btn-active-color-danger'
        style={{marginTop: '-9px'}}
        type='button'
        data-bs-toggle='dropdown'
        aria-expanded='true'
      >
        {icon ? (
          icon
        ) : (
          <i className='ki-duotone ki-dots-square-vertical fs-3x' style={{marginBottom: '-10px'}}>
            <span className='path1'></span>
            <span className='path2'></span>
            <span className='path3'></span>
            <span className='path4'></span>
          </i>
        )}
      </button>
      <ul className='dropdown-menu'>{children}</ul>
    </div>
  )
}

interface IDropList {
  children: ReactNode
}

const DropList = ({children}: IDropList) => {
  return <li>{children}</li>
}

interface IDropAction {
  action: VoidFunction
  label: string
  index: number
}

const DropAction = ({action, label, index}: IDropAction) => {
  return (
    <button key={`Dropdown${index}`} onClick={action} className='dropdown-item'>
      {label}
    </button>
  )
}

export const DropdownPattern = {
  Root: DropRoot,
  List: DropList,
  Action: DropAction,
}
